module.exports = __webpack_public_path__ + "assets/img/returnBtn-fa82edeb.png";